<template>
  <div v-if="receita.id" class="card card-body shadow-sm mt-0">
    <div class="form-header d-flex justify-content-between align-items-center">
      <h4 class="form-title">Detalhes da Receita nº {{ receita.id }}</h4>
      <button class="btn btn-secondary" @click="voltar">Voltar</button>
    </div>

    <FormSection title="Informações da Receita">
      <div class="info-group">
        <strong>Plano de Contas: </strong>
        <span v-if="receita.plano_contas === 'Mensalidade'" class="text-success">
          {{ receita.plano_contas }}
        </span>
        <span v-else-if="receita.plano_contas === 'Matrícula'" class="text-primary">
          {{ receita.plano_contas }}
        </span>
      </div>
      <div class="info-group">
        <strong>Descrição:</strong> {{ receita.descricao || '-' }}
      </div>
      <div class="info-group">
        <strong>Valor:</strong> {{ formatCurrency(receita.valor) }}
      </div>
      <div class="info-group">
        <strong>Vencimento:</strong> {{ formatDate(receita.data_vencimento) }}
      </div>
      <div class="info-group">
        <strong>Pagamento: </strong>
        <span v-if="receita.data_pagamento">
          {{ formatDate(receita.data_pagamento) }}
        </span>
        <span v-else class="text-danger">Pendente</span>
      </div>
      <div class="info-group">
        <strong>Forma de Pagamento:</strong> {{ receita.forma_pagamento || '-' }}
      </div>
      <div v-if="isCheque" class="info-group">
        <strong>Banco nº:</strong> {{ receita.banco_numero || '-' }}
      </div>
      <div v-if="isCheque" class="info-group">
        <strong>Agência:</strong> {{ receita.agencia || '-' }}
      </div>
      <div v-if="isCheque" class="info-group">
        <strong>Cheque nº:</strong> {{ receita.cheque_numero || '-' }}
      </div>
      <div class="info-group">
        <strong>Observações:</strong> {{ receita.observacoes || '-' }}
      </div>
    </FormSection>
  </div>

  <div v-else>
    <LoadingSpinner />
  </div>
</template>

<script>
import { reactive, onMounted, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import axios from '@/services/axios';
import FormSection from '@/components/Layout/FormSection.vue';
// import LoadingSpinner from '@/components/Layout/LoadingSpinner.vue';
import globalUtils from '@/utils/globalUtils';

export default {
  name: 'DetalharReceitaPlano',
  components: { FormSection },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const receita = reactive({});

    const carregarReceita = async (id) => {
      try {
        const { data } = await axios.get(`/financeiro/receitas-planos/${id}`);
        Object.assign(receita, data);
      } catch (err) {
        console.error('Erro ao carregar receita:', err);
      }
    };

    const isCheque = computed(() => {
      return receita.forma_pagamento?.toLowerCase() === 'cheque';
    });

    const voltar = () => {
      router.push('/financeiro/receitas-planos');
    };

    onMounted(() => {
      if (route.params.id) {
        carregarReceita(route.params.id);
      }
    });

    const formatDate = (dt) =>
      dt ? globalUtils.formatarData(dt) : '—';

    const formatCurrency = (val) =>
      val != null ? globalUtils.formatarValor(val) : '—';

    return {
      receita,
      isCheque,
      voltar,
      formatDate,
      formatCurrency
    };
  }
};
</script>

<style scoped>
.card {
  max-width: 90%;
  margin: 0 auto;
}
.form-header {
  margin-bottom: 1rem;
}
.form-header h4 {
  margin: 0;
}
.info-group {
  margin-bottom: 0.75rem;
}
</style>
